import { FunctionComponent, useMemo } from 'react';
import { useRequestCheckoutContext } from '../../../CheckoutContext/RequestContext';
import { PreferredDatesStep } from './PreferredDatesStep';
import { AvailableDateStep } from './AvailableDateStep';

export type DatesStepProps = {};

export const DatesStep: FunctionComponent<DatesStepProps> = () => {
    const { isCalendarBased } = useRequestCheckoutContext();

    if (isCalendarBased) {
        return <AvailableDateStep />;
    }

    return <PreferredDatesStep />;
};
